<template>
  <div>{{ data.text }}</div>
  <v-text-field
    v-model="value"
  ></v-text-field>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TextboxComponent',
  props: {
    data: Object,
    baseValue: [Object, String, Array, Boolean],
  },
  data: (props) => {
    return {
      value: props.baseValue,
    }
  },
  emits: ['formModEvent'],
  watch: {
    value() {
      this.sendDataToParent()
    },
  },
  methods: {
    sendDataToParent() {
      const dataToSend = [
        {
          key: this.data.name,
          value: this.value,
        },
      ]
      this.$emit('formModEvent', dataToSend)
    },
  },
})
</script>
